export const DATE_FORMAT = (providerDate) => providerDate || window.DATE_FORMAT || "MM/dd/yyyy"